import Carousel from "@components/Carousel";
import PopularPlaylists from "@components/Home/PopularPlaylists";
import LBox from "@components/LBox";
import LButton from "@components/LButton";
import LIcon from "@components/LIcon";
import LScreen from "@components/LScreen";
import LScrollView from "@components/LScrollView";
import LText from "@components/LText";
import { CreatePlaylistModalSWMSheet } from "@components/modals/CreatePlaylistModalSWM";
import LargeTile from "@components/LargeTile";
import { useLibrary } from "@hooks/trpc/useLibrary";
import { useMusicSyncGetPlaylistSyncProgress } from "@hooks/trpc/useMusicSync";
import { router } from "expo-router";
import { useBottomSheetManager } from "react-native-bottom-sheet-stack";

const MyPlaylists = ({
  playlists,
}: {
  playlists: ReturnType<typeof useLibrary>["myPlaylists"];
}) => {
  if (playlists.length === 0) {
    return null;
  }

  return (
    <Carousel
      data={playlists}
      renderItem={({ item }) => (
        <LargeTile item={item} screen="home" showPlaylistOwner={false} />
      )}
      title="My playlists"
    />
  );
};

export const EmptyScreen = () => {
  const bottomSheetManager = useBottomSheetManager();
  const syncProgress = useMusicSyncGetPlaylistSyncProgress();
  const { myPlaylists } = useLibrary();
  const hasImportedPlaylists = (syncProgress?.importedPlaylistCount ?? 0) > 0;

  return (
    <LScreen paddingHorizontal="zero" enableAutomaticTopPadding>
      <LScrollView contentContainerStyle={{ flexGrow: 1 }}>
        <LBox alignItems="center" pt="l3" pb="m2" px="s4">
          <LIcon name="empty_playlist" size={100} />
          <LText mt="s3" variant="messageTitle" fontWeight="bold">
            Your Playlist Queue is empty
          </LText>
          <LText mt="s2" variant="bodyM2m" color="greyText" textAlign="center">
            {`Tracks you play from Library or Explore\nwill appear here.`}
          </LText>

          <LBox gap="m1" flexDirection="row" mt="m2" width="100%">
            <LButton
              label="EXPLORE MUSIC"
              onPress={() => {
                router.navigate("/explore");
              }}
              sentryEventName="empty_playlist_explore_music"
              borderRadius="max"
              py="s3"
              textVariant="bodyM2Black"
              lPressableStyle={{
                flex: 1,
              }}
            />
            {hasImportedPlaylists ? (
              <LButton
                label="OPEN LIBRARY"
                variant="tertiary"
                onPress={() => {
                  router.navigate("/library");
                }}
                sentryEventName="empty_playlist_open_library"
                borderRadius="max"
                textVariant="bodyM2"
                py="s3"
                lPressableStyle={{
                  flex: 1,
                }}
              />
            ) : (
              <LButton
                label="CREATE PLAYLIST"
                variant="tertiary"
                onPress={() => {
                  bottomSheetManager.open(<CreatePlaylistModalSWMSheet />, {
                    mode: "push",
                  });
                }}
                sentryEventName="empty_playlist_create_playlist"
                borderRadius="max"
                textVariant="bodyM2"
                py="s3"
                lPressableStyle={{
                  flex: 1,
                }}
              />
            )}
          </LBox>
        </LBox>

        <LBox gap="m2" pb="l3">
          {hasImportedPlaylists && <MyPlaylists playlists={myPlaylists} />}
          <PopularPlaylists title="Popular playlists" />
        </LBox>
      </LScrollView>
    </LScreen>
  );
};
